const getQuerySeparator = (url) => {
  if (url.includes("?")) {
    if (url.endsWith("?") || url.endsWith("&")) {
      return "";
    }
    return "&";
  }
  return "?";
};

export const generateFullDeeplinkUrl = (deeplink) => {
  if (!deeplink?.base_url) {
    return "-";
  }

  const {
    base_url: baseUrl,
    base_parameters: baseParameters = [],
    custom_parameters: customParameters = [],
  } = deeplink;
  const queryParams = [];

  baseParameters.forEach((param) => {
    if (param) {
      queryParams.push(`${param}={${param}}`);
    }
  });

  customParameters.forEach(({ name, value }) => {
    if (name && value !== undefined && value !== null) {
      const trimmedName = String(name).trim();
      const stringValue = String(value).trim();

      if (trimmedName) {
        queryParams.push(`${trimmedName}=${stringValue}`);
      }
    }
  });

  if (queryParams.length === 0) {
    return baseUrl;
  }

  const separator = getQuerySeparator(baseUrl);

  return `${baseUrl}${separator}${queryParams.join("&")}`;
};
